import { useEffect, useMemo, useRef, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

// material-ui
import { useTheme } from '@mui/material/styles';
import {
  Box,
  ClickAwayListener,
  Grid,
  List,
  ListItemButton,
  ListItemText,
  Paper,
  Popper,
  Stack,
  Typography,
  useMediaQuery
} from '@mui/material';

// third-party
import Flag from 'react-flagkit';

// project-imports
import MainCard from 'components/MainCard';
import IconButton from 'components/@extended/IconButton';
import Transitions from 'components/@extended/Transitions';
import useConfig from 'hooks/useConfig';
import { USER_COUNTRY_CODE, USER_LANGUAGE } from 'components/Locales';
import useAuth from 'hooks/useAuth';
import { getAvailableUiLanguages } from 'utils/countryMarket';

// types
import { I18n } from 'types/config';
import Avatar from 'components/@extended/Avatar';

// ==============================|| HEADER CONTENT - LOCALIZATION ||============================== //

interface Props {
  size?: 'small' | 'medium' | 'large';
}

const Localization = ({ size = 'large' }: Props) => {
  const theme = useTheme();
  const matchesXs = useMediaQuery(theme.breakpoints.down('md'));

  const { i18n, onChangeLocalization } = useConfig();
  const { user } = useAuth();
  const [searchParams] = useSearchParams();

  const contextCode = user?.parentCode || user?.code || searchParams.get('code');
  const userCountry = user?.parentCountry || user?.country || localStorage.getItem(USER_COUNTRY_CODE);

  const availableUiLanguages = useMemo(
    () =>
      getAvailableUiLanguages({
        contextCode,
        userCountry
      }),
    [contextCode, userCountry]
  );

  const languageOptions = useMemo(
    () =>
      [
        { code: 'en' as I18n, label: 'English', flag: 'GB' },
        { code: 'es' as I18n, label: 'Español', flag: 'ES' },
        { code: 'pt' as I18n, label: 'Português', flag: 'PT' },
        { code: 'ka' as I18n, label: 'ქართული', flag: 'GE' },
        { code: 'ru' as I18n, label: 'Русский', flag: 'RU' }
      ].filter((option) => availableUiLanguages.includes(option.code)),
    [availableUiLanguages]
  );
  const activeLanguageOption = languageOptions.find((option) => option.code === i18n) || languageOptions[0];

  const anchorRef = useRef<any>(null);
  const [open, setOpen] = useState(false);
  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event: MouseEvent | TouchEvent) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpen(false);
  };

  const handleListItemClick = (lang: I18n) => {
    localStorage.setItem(USER_LANGUAGE, lang);
    onChangeLocalization(lang);
    setOpen(false);
  };

  useEffect(() => {
    if (!languageOptions.some((option) => option.code === i18n)) {
      localStorage.setItem(USER_LANGUAGE, 'es');
      onChangeLocalization('es');
    }
  }, [i18n, languageOptions, onChangeLocalization]);

  // const iconBackColorOpen = theme.palette.mode === ThemeMode.DARK ? 'secondary.200' : 'secondary.200';
  // const iconBackColor = theme.palette.mode === ThemeMode.DARK ? 'background.default' : 'secondary.100';

  return (
    // <Box sx={{ flexShrink: 0, ml: 0.5 }}>
    //   <IconButton
    //     color="secondary"
    //     variant="light"
    //     aria-label="open localization"
    //     ref={anchorRef}
    //     aria-controls={open ? 'localization-grow' : undefined}
    //     aria-haspopup="true"
    //     onClick={handleToggle}
    //     size="large"
    //     sx={{ color: 'secondary.main', bgcolor: open ? iconBackColorOpen : iconBackColor, p: 1 }}
    //   >
    //     <LanguageSquare variant="Bulk" size={26} />
    //   </IconButton>
    //   <Popper
    //     placement={matchesXs ? 'bottom-start' : 'bottom'}
    //     open={open}
    //     anchorEl={anchorRef.current}
    //     role={undefined}
    //     transition
    //     disablePortal
    //     popperOptions={{
    //       modifiers: [
    //         {
    //           name: 'offset',
    //           options: {
    //             offset: [matchesXs ? 0 : 0, 9]
    //           }
    //         }
    //       ]
    //     }}
    //   >
    //     {({ TransitionProps }) => (
    //       <Transitions type="grow" position={matchesXs ? 'top-right' : 'top'} in={open} {...TransitionProps}>
    //         <Paper sx={{ boxShadow: theme.customShadows.z1, borderRadius: 1.5 }}>
    //           <ClickAwayListener onClickAway={handleClose}>
    //             <MainCard border={false} content={false}>
    //               <List
    //                 component="nav"
    //                 sx={{
    //                   p: 1,
    //                   width: '100%',
    //                   minWidth: 200,
    //                   maxWidth: 290,
    //                   bgcolor: theme.palette.background.paper,
    //                   [theme.breakpoints.down('md')]: {
    //                     maxWidth: 250
    //                   }
    //                 }}
    //               >
    //                 {/* <ListItemButton selected={i18n === 'en'} onClick={() => handleListItemClick('en')}>
    //                   <ListItemText
    //                     primary={
    //                       <Grid container>
    //                         <Typography color="textPrimary">English</Typography>
    //                       </Grid>
    //                     }
    //                   />
    //                 </ListItemButton> */}
    //                 <ListItemButton selected={i18n === 'es'} onClick={() => handleListItemClick('es')}>
    //                   <ListItemText
    //                     primary={
    //                       <Grid container>
    //                         <Typography color="textPrimary">Español</Typography>
    //                       </Grid>
    //                     }
    //                   />
    //                 </ListItemButton>
    //               </List>
    //             </MainCard>
    //           </ClickAwayListener>
    //         </Paper>
    //       </Transitions>
    //     )}
    //   </Popper>
    // </Box>
    <Box sx={{ flexShrink: 0, ml: 0.5 }}>
      <IconButton
        ref={anchorRef}
        // size="small"
        // shape="rounded"
        size={size}
        color="secondary"
        variant="light"
        // sx={{
        //   // bgcolor: 'secondary.light',
        //   color: 'secondary.darker',
        //   '&:hover': { color: 'secondary.lighter', bgcolor: 'secondary.darker' }
        // }}
        sx={{ color: 'secondary.main', p: 1 }}
        onClick={handleToggle}
      >
        {/* <LanguageSquare /> */}
        <Avatar size="xs" sx={{ width: 24, height: 24 }}>
          {activeLanguageOption && <Flag country={activeLanguageOption.flag} style={{ height: '100%', width: 'auto' }} />}
        </Avatar>
      </IconButton>
      <Popper
        placement={matchesXs ? 'bottom' : 'bottom-end'}
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        disablePortal
        popperOptions={{
          modifiers: [
            {
              name: 'offset',
              options: {
                offset: [matchesXs ? 0 : 0, 9]
              }
            }
          ]
        }}
      >
        {({ TransitionProps }) => (
          <Transitions type="grow" position={matchesXs ? 'top-right' : 'top'} in={open} {...TransitionProps}>
            <Paper sx={{ boxShadow: theme.customShadows.z1, borderRadius: 1.5 }}>
              <ClickAwayListener onClickAway={handleClose}>
                <MainCard border={false} content={false}>
                  <List
                    component="nav"
                    sx={{
                      p: 1,
                      width: '100%',
                      minWidth: 200,
                      maxWidth: 290,
                      bgcolor: theme.palette.background.paper,
                      [theme.breakpoints.down('md')]: {
                        maxWidth: 250
                      }
                    }}
                  >
                    {/* <ListItemButton selected={i18n === 'de'} onClick={() => handleListItemClick('de')}>
                      <ListItemText
                        primary={
                          <Grid container>
                            <Stack direction="row" spacing={1}>
                              <Avatar size="xs" sx={{ width: 20, height: 20 }}>
                                <Flag country="DE" style={{ height: '100%', width: 'auto' }} />
                              </Avatar>
                              <Typography color="textPrimary">Deutsch</Typography>
                            </Stack>
                            <Typography variant="caption" color="textSecondary" sx={{ ml: '8px' }}></Typography>
                          </Grid>
                        }
                      />
                    </ListItemButton> */}
                    {languageOptions.map((option) => (
                      <ListItemButton key={option.code} selected={i18n === option.code} onClick={() => handleListItemClick(option.code)}>
                        <ListItemText
                          primary={
                            <Grid container>
                              <Stack direction="row" spacing={1}>
                                <Avatar size="xs" sx={{ width: 20, height: 20 }}>
                                  <Flag country={option.flag} style={{ height: '100%', width: 'auto' }} />
                                </Avatar>
                                <Typography color="textPrimary">{option.label}</Typography>
                              </Stack>
                              <Typography variant="caption" color="textSecondary" sx={{ ml: '8px' }}></Typography>
                            </Grid>
                          }
                        />
                      </ListItemButton>
                    ))}
                    {/* <ListItemButton selected={i18n === 'fr'} onClick={() => handleListItemClick('fr')}>
                      <ListItemText
                        primary={
                          <Grid container>
                            <Stack direction="row" spacing={1}>
                              <Avatar size="xs" sx={{ width: 20, height: 20 }}>
                                <Flag country="FR" style={{ height: '100%', width: 'auto' }} />
                              </Avatar>
                              <Typography color="textPrimary">Français</Typography>
                            </Stack>
                            <Typography variant="caption" color="textSecondary" sx={{ ml: '8px' }}></Typography>
                          </Grid>
                        }
                      />
                    </ListItemButton> */}
                    {/* <ListItemButton selected={i18n === 'nl'} onClick={() => handleListItemClick('nl')}>
                      <ListItemText
                        primary={
                          <Grid container>
                            <Stack direction="row" spacing={1}>
                              <Avatar size="xs" sx={{ width: 20, height: 20 }}>
                                <Flag country="NL" style={{ height: '100%', width: 'auto' }} />
                              </Avatar>
                              <Typography color="textPrimary">Nederlands</Typography>
                            </Stack>
                            <Typography variant="caption" color="textSecondary" sx={{ ml: '8px' }}></Typography>
                          </Grid>
                        }
                      />
                    </ListItemButton> */}
                    {/* <ListItemButton selected={i18n === 'pl'} onClick={() => handleListItemClick('pl')}>
                      <ListItemText
                        primary={
                          <Grid container>
                            <Stack direction="row" spacing={1}>
                              <Avatar size="xs" sx={{ width: 20, height: 20 }}>
                                <Flag country="PL" style={{ height: '100%', width: 'auto' }} />
                              </Avatar>
                              <Typography color="textPrimary">Polski</Typography>
                            </Stack>
                            <Typography variant="caption" color="textSecondary" sx={{ ml: '8px' }}></Typography>
                          </Grid>
                        }
                      />
                    </ListItemButton> */}
                    {/* <ListItemButton selected={i18n === 'ru'} onClick={() => handleListItemClick('ru')}>
                    <ListItemText
                      primary={
                        <Grid container>
                          <Typography color="textPrimary">Русский</Typography>
                          <Typography variant="caption" color="textSecondary" sx={{ ml: '8px' }}></Typography>
                        </Grid>
                      }
                    />
                  </ListItemButton> */}
                  </List>
                </MainCard>
              </ClickAwayListener>
            </Paper>
          </Transitions>
        )}
      </Popper>
    </Box>
  );
};

export default Localization;
